/**
 * 共通メソッド
 * common.js
 */

import Vue from 'vue'
import errorCode from './errorCode'

// 日付のフォーマット
export function parseTime (time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time
        .replace(new RegExp(/-/gm), '/')
        .replace('T', ' ')
        .replace(new RegExp(/\.[\d]{3}/gm), '')
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// フォームリセット
export function resetForm (refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields()
  }
}

// 日付範囲を追加
export function addDateRange (params, dateRange, propName) {
  let search = params
  search.params =
    typeof search.params === 'object' && search.params !== null && !Array.isArray(search.params)
      ? search.params
      : {}
  dateRange = Array.isArray(dateRange) ? dateRange : []
  if (typeof propName === 'undefined') {
    search.params['beginTime'] = dateRange[0]
    search.params['endTime'] = dateRange[1]
  } else {
    search.params['begin' + propName] = dateRange[0]
    search.params['end' + propName] = dateRange[1]
  }
  return search
}

// データ ディクショナリ返し
export function selectDictLabel (datas, value) {
  if (value === undefined) {
    return ''
  }
  var actions = []
  Object.keys(datas).some(key => {
    if (datas[key].value == '' + value) {
      actions.push(datas[key].label)
      return true
    }
  })
  if (actions.length === 0) {
    actions.push(value)
  }
  return actions.join('')
}

// データ ディクショナリ(文字列の配列)返し
export function selectDictLabels (datas, value, separator) {
  if (value === undefined) {
    return ''
  }
  var actions = []
  var currentSeparator = undefined === separator ? ',' : separator
  var temp = value.split(currentSeparator)
  Object.keys(value.split(currentSeparator)).some(val => {
    var match = false
    Object.keys(datas).some(key => {
      if (datas[key].value == '' + temp[val]) {
        actions.push(datas[key].label + currentSeparator)
        match = true
      }
    })
    if (!match) {
      actions.push(temp[val] + currentSeparator)
    }
  })
  return actions.join('').substring(0, actions.join('').length - 1)
}

// 文字列フォーマット (%s)
export function sprintf (str) {
  var args = arguments,
    flag = true,
    i = 1
  str = str.replace(/%s/g, function () {
    var arg = args[i++]
    if (typeof arg === 'undefined') {
      flag = false
      return ''
    }
    return arg
  })
  return flag ? str : ''
}

// 文字列を変換する，undefined,nullは "" に変換されます
export function parseStrEmpty (str) {
  if (!str || str == 'undefined' || str == 'null') {
    return ''
  }
  return str
}

// データマージ
export function mergeRecursive (source, target) {
  for (var p in target) {
    try {
      if (target[p].constructor == Object) {
        source[p] = mergeRecursive(source[p], target[p])
      } else {
        source[p] = target[p]
      }
    } catch (e) {
      source[p] = target[p]
    }
  }
  return source
}

/**
 * ツリー構造データの構築
 * @param {*} data データ ソース
 * @param {*} id id
 * @param {*} parentId 'parentId'
 * @param {*} children 'children'
 */
export function handleTree (data, id, parentId, children) {
  let config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children'
  }

  var childrenListMap = {}
  var nodeIds = {}
  var tree = []

  for (let d of data) {
    let parentId = d[config.parentId]
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = []
    }
    nodeIds[d[config.id]] = d
    childrenListMap[parentId].push(d)
  }

  for (let d of data) {
    let parentId = d[config.parentId]
    if (nodeIds[parentId] == null) {
      tree.push(d)
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t)
  }

  function adaptToChildrenList (o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]]
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c)
      }
    }
  }
  return tree
}

/**
 * パラメータ処理
 * @param {*} params  パラメータ
 */
export function tansParams (params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName]
    var part = encodeURIComponent(propName) + '='
    if (value !== null && value !== '' && typeof value !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== '' && typeof value[key] !== 'undefined') {
            let params = propName + '[' + key + ']'
            var subPart = encodeURIComponent(params) + '='
            result += subPart + encodeURIComponent(value[key]) + '&'
          }
        }
      } else {
        result += part + encodeURIComponent(value) + '&'
      }
    }
  }
  return result
}

// BLOB 形式であることを確認する
export async function blobValidate (data) {
  try {
    const text = await data.text()
    JSON.parse(text)
    return false
  } catch (error) {
    return true
  }
}

// ファイルのダウンロード
export function downloadFile (data, fileName) {
  if (!data) {
    return
  }
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
}

/**
 * 単項目チェック
 * @param itemContents 項目内容
 * @param checkKbn チェック区分
 * @param msgId メッセージＩＤ
 * @param args メッセージ引数
 * @returns メッセージ内容
 */
export function singleItemCheck (itemContents, checkKbn, msgId, ...args) {
  let msg = ''
  // チェック区分
  switch (checkKbn) {
    case EnumSingleItemKbn.ALPHANUMERIC:
      msg =
        itemContents == '' || /^[A-Za-z0-9]+$/.test(itemContents)
          ? ''
          : Vue.prototype.$stringFormat(errorCode[msgId], ...args)
      break
    case EnumSingleItemKbn.NUMERIC:
      msg =
        itemContents == '' || /^[0-9]+$/.test(itemContents)
          ? ''
          : Vue.prototype.$stringFormat(errorCode[msgId], ...args)
      break
    case EnumSingleItemKbn.MAXIMUM:
      msg =
        itemContents.length > args[1] ? Vue.prototype.$stringFormat(errorCode[msgId], ...args) : ''
      break
    case EnumSingleItemKbn.REQUIRED:
      msg =
        itemContents == null || itemContents == ''
          ? Vue.prototype.$stringFormat(errorCode[msgId], ...args)
          : ''
      break
    case EnumSingleItemKbn.FROMTO:
      msg = itemContents > args[2] ? Vue.prototype.$stringFormat(errorCode[msgId], ...args) : ''
      break
    case EnumSingleItemKbn.MAILADDRESS:
      msg =
        itemContents == '' || /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/.test(itemContents)
          ? ''
          : Vue.prototype.$stringFormat(errorCode[msgId], args)
      break
    default:
      msg = Vue.prototype.$stringFormat(errorCode[msgId], ...args)
      break
  }
  return msg
}

// 単項目区分ENUM
export const EnumSingleItemKbn = {
  // 英数字
  ALPHANUMERIC: '英数字',
  // 最大文字数
  MAXIMUM: '最大文字数',
  // 必須
  REQUIRED: '必須',
  // 数字
  NUMERIC: '数字',
  // FROMTO
  FROMTO: 'FromTO',
  // メールアドレス
  MAILADDRESS: 'メールアドレス'
}

/**
 * メッセージ内容を取得する
 * @param msgId メッセージＩＤ
 * @param args メッセージ引数
 * @returns メッセージ内容
 */
export function getMessageContent (msgId, ...args) {
  return Vue.prototype.$stringFormat(errorCode[msgId], ...args)
}

/**
 * 西暦日（Date） ⇒ 和暦(GGGGy年M月d日)変換
 * @param date 西暦日（Date）
 * @returns 和暦(GGGGy年M月d日)
 */
export function parseDateToWareki (date) {
  return date.toLocaleDateString('ja-JP-u-ca-japanese', {
    era: 'long', // 時代 : 'narrow' にすると '平成' は 'H' になる
    year: 'numeric', // 年 : 'ja-JP-u-ca-japanese' の場合は和暦
    month: 'long', // 月
    day: 'numeric' // 日
  })
}
export function timeConversion (date) {
  return new Date(date)
    .toLocaleDateString('ja-JP-u-ca-japanese', {
      era: 'narrow', // 時代 : 'narrow' にすると '平成' は 'H' になる
      year: 'numeric', // 年 : 'ja-JP-u-ca-japanese' の場合は和暦
      month: 'numeric', // 月
      day: 'numeric' // 日
    })
    .split('/')
    .join('.')
}

/**
 * 日付（String） ⇒ 日付（Date）変換
 * @param date 日付（String）
 * @returns 日付（Date）
 */
export function strToDate (date) {
  if (date !== null && date !== '') {
    return parseDateToWareki(new Date(date))
  }
  return date
}

/**
 * 西暦日（Date） ⇒ 和暦(GGGGy年M月d日 hh:mm:ss)変換
 * @param date 西暦日（Date）
 * @returns 和暦(GGGGy年M月d日 hh:mm:ss)
 */
export function parseDateTimeToWareki (date) {
  return date.toLocaleDateString('ja-JP-u-ca-japanese', {
    era: 'long', // 時代 : 'narrow' にすると '平成' は 'H' になる
    year: 'numeric', // 年 : 'ja-JP-u-ca-japanese' の場合は和暦
    month: 'long', // 月
    day: 'numeric', // 日
    hour: 'numeric', // 時
    minute: 'numeric', // 分
    second: 'numeric' // 秒
  })
}

/**
 * 日付（String） ⇒ 日付（DateTime）変換
 * @param date 日付（String）
 * @returns 和暦(GGGGyy年MM月dd日 hh:mm:ss)
 */
export function strToDateTime (date) {
  if (date !== null && date !== '') {
    const dateStrArr = new Date(date).toLocaleDateString('ja-JP-u-ca-japanese', {
      era: 'long', // 時代 : 'narrow' にすると '平成' は 'H' になる
      year: '2-digit', // 年 : 'ja-JP-u-ca-japanese' の場合は和暦
      month: '2-digit', // 月
      day: '2-digit', // 日
      hour: '2-digit', // 時
      minute: '2-digit', // 分
      second: '2-digit' // 秒
    }).split('/')
    return ['年', '月', '日'].reduce((prev, cur, index, arr) => {
      if (index == 1) {
        return dateStrArr[index - 1] + prev + dateStrArr[index] + cur
      } else {
        return prev + dateStrArr[index].split(' ').join(cur + ' ')
      }
    })
  }
  return date
}

/**
 * 全角のアラビア数字、漢数字（String） ⇒ 半角のアラビア数字（Number）変換
 * @param str 数字（String）
 * @returns 半角のアラビア数字
 */
export function strToNumber (str) {
  const kans = '〇一二三四五六七八九'
  const nums = '０１２３４５６７８９'
  const reg = /^[0-9]+$/
  if (str !== '' && !reg.test(str)) {
    let tmp, kanIndex, numIndex
    for (let i = 0; i < str.length; i++) {
      kanIndex = kans.indexOf(str[i])
      numIndex = nums.indexOf(str[i])
      if (kanIndex === -1 && numIndex === -1) {
        continue;
      } else {
        if (kanIndex !== -1) {
          str = str.replace(kans[kanIndex], kanIndex)
        } else {
          str = str.replace(nums[numIndex], numIndex)
        }
      }
    }
  }

  return str.replace(/^[0]+/, '');
}



export function transformNumChar (str) {
  const kans = ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const nums = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
  const strList = str.split("")
  for (let item of strList) {
    var index = nums.indexOf(item);
    if (index !== -1) {
      str = str.replace(item, kans[index])
    }
  }
  return str
}
